import { render } from "./GearInsightsView.vue?vue&type=template&id=9b2e98c0"
import script from "./GearInsightsView.vue?vue&type=script&lang=js"
export * from "./GearInsightsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__